export const FETCH_REVENUE_REQUEST = 'FETCH_REVENUE_REQUEST';
export const FETCH_REVENUE_SUCCESS = 'FETCH_REVENUE_SUCCESS';
export const FETCH_REVENUE_FAILURE = 'FETCH_REVENUE_FAILURE';